import React from "react";

export default function SupportIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg viewBox="0 0 36 36" fill="none" style={{ ...filteredStyles, fill: "none" }} className={props.className} xmlns="http://www.w3.org/2000/svg">
      <path d="m18 2a16 16 0 1 0 16 16 16 16 0 0 0 -16-16zm5.2 19.7a6.39 6.39 0 0 0 0-7.39l5.32-5.31a13.8 13.8 0 0 1 0 18zm-8.2-6.7a4.27 4.27 0 1 1 0 6 4.26 4.26 0 0 1 0-6zm12-7.5-5.3 5.3a6.39 6.39 0 0 0 -7.39 0l-5.31-5.32a13.8 13.8 0 0 1 18 0zm-19.52 1.5 5.32 5.3a6.39 6.39 0 0 0 0 7.39l-5.32 5.31a13.8 13.8 0 0 1 0-18zm1.52 19.52 5.3-5.32a6.4 6.4 0 0 0 7.39 0l5.31 5.32a13.8 13.8 0 0 1 -18 0z" fill={filteredStyles.fill || "#FFF"}/>
    </svg>
  );
}
